import { usePathname } from "next/navigation";
import theme from "@config/theme";

const EmailButton = () => {
  const pathname = usePathname();
  const basePath = process.env.NEXT_PUBLIC_SITE_URL;

  return (
    <>
      <a
        className="social-share-button email-button"
        href={`mailto:?subject=Check out this blog post&body=${basePath}${pathname}`}
        aria-label="Share via email"
      >
        <span className="material-icons-round">email</span>
      </a>
      <style jsx>
        {`
          span {
            font-size: ${theme.fonts.size.px22};
          }
        `}
      </style>
    </>
  );
};

export default EmailButton;
